<script setup>
import Header from '@/Components/Header.vue';
import Footer from '@/Components/Footer.vue';
import Button from '@/Components/Button.vue';
import CustomLink from '@/Components/CustomLink.vue';
import TestimonialSlider from '@/Components/TestimonialSlider.vue';
import { useForm, Head } from '@inertiajs/vue3';
import 'primeicons/primeicons.css'
import { ref, inject, onMounted } from 'vue'
import { Dialog, DialogPanel, DialogTitle, TransitionChild, TransitionRoot, Disclosure, DisclosureButton, DisclosurePanel, Popover, PopoverButton, PopoverPanel } from '@headlessui/vue';
import { Switch } from '@headlessui/vue';
import LicensePlateBanner from '@/Components/LicensePlateBanner.vue'; // Replace LicensePlateInput with LicensePlateBanner
import LicensePlateInputForm from '@/Components/LicensePlateInputForm.vue';

const contactFormSuccess = ref(null)
const contactFormError = ref(null)
const contactFormDom = ref(null)

const contactForm = useForm({
    first_name: null,
    last_name: null,
    email: null,
    phone_number: null,
    message: null
})

function submitContact(e) {
    contactForm.post('/contact', {
        onSuccess: () => {
            contactForm.reset();

            //hide contactFormDom, show success message
            contactFormDom.value.style.display = 'none';
            contactFormSuccess.value.style.display = 'block';
        },
        onError: (response) => {
            if (response.first_name || response.last_name || response.email || response.phone_number || response.message) {
                return;
            }

            //hide contactFormDom, show error message
            contactFormDom.value.style.display = 'none';
            contactFormError.value.style.display = 'block';
        },
        preserveScroll: true
    })
}

const faqs = [
    {
        "id": 1,
        "question": "Hoe werkt het verkoopproces bij mijnautosnelweg.nl?",
        "answer": "Het proces is eenvoudig en snel. Vul je kenteken in op onze website en ontvang binnen 24 uur een vrijblijvend bod. Als je het bod accepteert, kun je de verkoop online regelen. Wij werken samen met erkende autobedrijven om een veilige en betrouwbare transactie te garanderen."
    },
    {
        "id": 2,
        "question": "Hoe lang duurt het voordat ik een bod ontvang?",
        "answer": "Binnen 24 uur na het invoeren van je kenteken ontvang je een bod. Dit geeft je de mogelijkheid om snel te beslissen en je auto te verkopen zonder vertragingen."
    },
    {
        "id": 3,
        "question": "Wat kost het om mijn auto te verkopen via mijnautosnelweg.nl?",
        "answer": "Onze dienst is volledig gratis en vrijblijvend. Er zijn geen verborgen kosten of verplichtingen. Je beslist zelf of je het bod accepteert."
    },
    {
        "id": 4,
        "question": "Met welke autobedrijven werkt mijnautosnelweg.nl samen?",
        "answer": "Wij werken samen met erkende en betrouwbare autobedrijven in heel Nederland. Dit zorgt ervoor dat je een eerlijk bod krijgt en dat de verkoop veilig en professioneel wordt afgehandeld."
    },
    {
        "id": 5,
        "question": "Moet ik mijn auto ergens naartoe brengen voor inspectie?",
        "answer": "Nee, in de meeste gevallen is een inspectie niet nodig. Ons netwerk van autobedrijven kan de benodigde informatie op basis van je kenteken en beschrijving beoordelen. Mocht er toch een inspectie nodig zijn, dan bespreken we dit met je."
    },
]

const faqs2 = [
    {
        "id": 6,
        "question": "Wat gebeurt er nadat ik het bod heb geaccepteerd?",
        "answer": "Nadat je het bod hebt geaccepteerd, nemen we contact met je op om de verdere details te bespreken en de verkoop af te ronden. We begeleiden je bij elke stap om ervoor te zorgen dat alles soepel verloopt."
    },
    {
        "id": 7,
        "question": "Kan ik mijn auto nog gebruiken nadat ik het bod heb geaccepteerd?",
        "answer": "Ja, je kunt je auto blijven gebruiken tot het moment van de officiële overdracht. We plannen een geschikte datum en tijd voor de overdracht die voor jou het beste uitkomt."
    },
    {
        "id": 8,
        "question": "Wat als ik niet tevreden ben met het bod?",
        "answer": "Als je niet tevreden bent met het bod, ben je niet verplicht om het te accepteren. Onze dienst is geheel vrijblijvend, en je kunt altijd besluiten om je auto op een andere manier te verkopen."
    },
    {
        "id": 9,
        "question": "Hoe bepaal ik de waarde van mijn auto?",
        "answer": "De waarde van je auto wordt bepaald op basis van verschillende factoren, waaronder het merk, model, bouwjaar, kilometerstand en algehele conditie. Onze partners gebruiken geavanceerde waarderingsmodellen om een eerlijk en marktconform bod te bieden."
    },
    {
        "id": 10,
        "question": "Wat moet ik doen als ik een probleem ondervind tijdens het verkoopproces?",
        "answer": "Als je een probleem ondervindt of vragen hebt tijdens het verkoopproces, kun je altijd contact opnemen met onze klantenservice. Wij staan klaar om je te helpen en eventuele problemen snel op te lossen."
    },
]

const testimonials = [
    {
        body: 'Ik heb recentelijk gebruik gemaakt van Mijnautosnelweg.nl en ik ben zeer tevreden over de service. De medewerkers waren vriendelijk en behulpzaam, en ze boden een eerlijke prijs voor mijn auto. Ik kan ze zeker aanraden aan anderen die op zoek zijn naar een betrouwbare service!',
        author: {
            name: 'Dylan Van der zee',
            date: '12 september'
        },
    },
    {
        body: '⭐️⭐️⭐️⭐️⭐️ Enorm tevreden! Even geleden onze Volvo kunnen verkopen via MijnAutoSnelWeg.nl. Na een vriendelijk gesprek te hebben gehad een mooi bod mogen ontvangen en alles was zo geregeld! Top service ⭐️⭐️⭐️⭐️⭐️',
        author: {
            name: 'Robin Meijer',
            date: '16 april'
        },
    },
    {
        body: 'Ik ben ontzettend tevreden over mijnautosnelweg.nl! Ik kreeg een topaanbod voor mijn bmw 3 serie en alles werd precies zo afgehandeld als beloofd, zonder dat het bod lager uitviel dan het online aanbod. De communicatie was duidelijk en prettig, en alles werd snel en efficiënt geregeld. Echt een aanrader voor wie een betrouwbare en snelle service zoekt, zonder verrassingen!',
        author: {
            name: 'Aram Tygranov',
            date: '18 oktober'
        },
    },
    {
        body: 'Een erg positieve ervaring. Het hele team was professioneel en ook erg behulpzaam. Mijn auto is binnen een week verkocht voor een mooie prijs! Dit is zeker de manier om je auto te verkopen.',
        author: {
            name: 'Kiico Cardano',
            date: '4 september'
        },
    },
    {
        body: 'Auto verkocht via mijnautosnelweg. Heerlijk hoe vlot en snel alles is gelopen!',
        author: {
            name: 'Setrak Awanesian',
            date: '16 april'
        },
    },
    // More testimonials...
]

const features = [
    {
        name: 'Snel en eenvoudig proces',
        description:
            'Voer je kenteken in en ontvang binnen 24 uur een bod.',
        icon: 'stopwatch',
    },
    {
        name: 'Betrouwbaar en veilig',
        description: 'Wij werken samen met erkende autobedrijven.',
        icon: 'building-shield',
    },
    {
        name: 'Gratis en vrijblijvend',
        description: 'Geen verplichtingen, je beslist zelf of je het bod accepteert.',
        icon: 'handshake',
    },
]

const contacts = [
    {
        name: 'Telefoon',
        description: '085 04 777 66',
        icon: 'phone',
        type: 'far',
        href: 'tel:+31850477766'
    },
    {
        name: 'WhatsApp',
        description:
            '+31 85 0477766',
        icon: 'whatsapp',
        type: 'fab',
        href: 'https://wa.me/31850477766'
    },
    {
        name: 'E-mail',
        description: 'info@mijnautosnelweg.nl',
        icon: 'envelope',
        type: 'far',
        href: 'mailto:info@mijnautosnelweg.nl'
    },
]

const form = useForm({
    license_plate: ''
});

function submit() {
    form.post('/kenteken', {
        onSuccess: () => {
            // form.reset();
        },
        onError: () => {
            // form.reset();
        }
    });
}

const showEssential = ref(false)
const showAnalytics = ref(false)
const showCookie = ref(false)
const showCookieSettings = ref(false)
const acceptAnalytics = ref(false)
//check if cookies need to be shown
const $cookies = inject('$cookies');
if ($cookies.get('cookie-consent') === undefined || $cookies.get('cookie-consent') === null) {
    showCookie.value = true
} else {
    showCookie.value = false
}

function acceptCookies() {
    $cookies.set('cookie-consent', 'true', "1y");
    showCookie.value = false
    showCookieSettings.value = false
    if (acceptAnalytics.value) {
        //set cookie that anyalytics are accepted
        $cookies.set('cookie-analytics', 'true', "1y");
        setCookiesAsScripts();
    }
}

function acceptAllCookies() {   
    $cookies.set('cookie-consent', 'true', "1y");
    $cookies.set('cookie-analytics', 'true', "1y");
    setCookiesAsScripts();
    showCookie.value = false
    showCookieSettings.value = false
}

function setCookiesAsScripts() {
    //check if gtag function is available
    if (typeof gtag === 'function') {
        //do cookie consent mode v2
        //set google analytics
        gtag('consent', 'update', {
            'ad_storage': $cookies.get('cookie-analytics') == "true" ? 'granted' : 'denied',
            'analytics_storage': $cookies.get('cookie-analytics') == "true" ? 'granted' : 'denied',
            'ad_user_data': $cookies.get('cookie-analytics') == "true" ? 'granted' : 'denied',
            'ad_personalization': $cookies.get('cookie-analytics') == "true" ? 'granted' : 'denied',
        });
    }
}

function checkCookies() {
    //check cookie-anaytics
    if ($cookies.get('cookie-analytics') !== undefined && $cookies.get('cookie-analytics') !== null) {
        setCookiesAsScripts();
    }
}

function GetSidecodeLicenseplate(Licenseplate) {
    var arrSC = new Array;
    var scUitz = '';

    Licenseplate = Licenseplate.replace('-', '').toUpperCase();

    arrSC[0] = /^[a-zA-Z]{2}[\d]{2}[\d]{2}$/ // 1 XX-99-99
    arrSC[1] = /^[\d]{2}[\d]{2}[a-zA-Z]{2}$/ // 2 99-99-XX
    arrSC[2] = /^[\d]{2}[a-zA-Z]{2}[\d]{2}$/ // 3 99-XX-99
    arrSC[3] = /^[a-zA-Z]{2}[\d]{2}[a-zA-Z]{2}$/ // 4 XX-99-XX
    arrSC[4] = /^[a-zA-Z]{2}[a-zA-Z]{2}[\d]{2}$/ // 5 XX-XX-99
    arrSC[5] = /^[\d]{2}[a-zA-Z]{2}[a-zA-Z]{2}$/ // 6 99-XX-XX
    arrSC[6] = /^[\d]{2}[a-zA-Z]{3}[\d]{1}$/ // 7 99-XXX-9
    arrSC[7] = /^[\d]{1}[a-zA-Z]{3}[\d]{2}$/ // 8 9-XXX-99
    arrSC[8] = /^[a-zA-Z]{2}[\d]{3}[a-zA-Z]{1}$/ // 9 XX-999-X
    arrSC[9] = /^[a-zA-Z]{1}[\d]{3}[a-zA-Z]{2}$/ // 10 X-999-XX
    arrSC[10] = /^[a-zA-Z]{3}[\d]{2}[a-zA-Z]{1}$/ // 11 XXX-99-X
    arrSC[11] = /^[a-zA-Z]{1}[\d]{2}[a-zA-Z]{3}$/ // 12 X-99-XXX
    arrSC[12] = /^[\d]{1}[a-zA-Z]{2}[\d]{3}$/ // 13 9-XX-999
    arrSC[13] = /^[\d]{3}[a-zA-Z]{2}[\d]{1}$/ // 14 999-XX-9

    //except licenseplates for diplomats
    scUitz = '^CD[ABFJNST][0-9]{1,3}$' //for example: CDB1 of CDJ45

    for (var i = 0; i < arrSC.length; i++) {
        if (Licenseplate.match(arrSC[i])) {
            return i + 1;
        }
    }
    if (Licenseplate.match(scUitz)) {
        return 'CD';
    }
    return false;
}

function FormatLicenseplate(Licenseplate, Sidecode) {

    Licenseplate = Licenseplate.replace('-', '').toUpperCase();

    if (Sidecode <= 6) {
        return Licenseplate.substr(0, 2) + '-' + Licenseplate.substr(2, 2) + '-' + Licenseplate.substr(4, 2)
    }
    if (Sidecode == 7 || Sidecode == 9) {
        return Licenseplate.substr(0, 2) + '-' + Licenseplate.substr(2, 3) + '-' + Licenseplate.substr(5, 1)
    }
    if (Sidecode == 8 || Sidecode == 10) {
        return Licenseplate.substr(0, 1) + '-' + Licenseplate.substr(1, 3) + '-' + Licenseplate.substr(4, 2)
    }
    if (Sidecode == 11 || Sidecode == 14) {
        return Licenseplate.substr(0, 3) + '-' + Licenseplate.substr(3, 2) + '-' + Licenseplate.substr(5, 1)
    }
    if (Sidecode == 12 || Sidecode == 13) {
        return Licenseplate.substr(0, 1) + '-' + Licenseplate.substr(1, 2) + '-' + Licenseplate.substr(3, 3)
    }
    return Licenseplate
}

function formatLicensePlate(e) {
    form.clearErrors('license_plate');
    let licensePlate = e.target.value;

    let sidecode = GetSidecodeLicenseplate(licensePlate);
    if (sidecode) {
        form.license_plate = FormatLicenseplate(licensePlate, sidecode);
    }
}

onMounted(() => {
    checkCookies();
})

// Create a ref to the LicensePlateInputForm component
const licenseInputRef = ref(null);

// Function to focus on the license input
function focusLicenseInput() {
  licenseInputRef.value?.focus();
}

// Add these new refs and functions for the comparison slider
const comparisonSlider = ref(null);
const activeCard = ref(1); // Start with the middle card (index 1)
const cardCount = 3; // Total number of comparison cards

function scrollToCard(index) {
    // Don't proceed if already scrolling
    if (isScrollingToCard.value) return;
    
    activeCard.value = index;
    
    // On mobile, scroll the container to show the selected card
    if (comparisonSlider.value && window.innerWidth < 1024) {
        isScrollingToCard.value = true;
        
        const cardWidth = comparisonSlider.value.offsetWidth;
        comparisonSlider.value.scrollTo({
            left: cardWidth * index,
            behavior: 'smooth',
        });
        
        // Reset the scrolling flag after animation completes (approx. 300ms for 'smooth' behavior)
        setTimeout(() => {
            isScrollingToCard.value = false;
        }, 300);
    }
}

const isScrollingToCard = ref(false);

function nextCard() {
    if (!isScrollingToCard.value) {
        scrollToCard(Math.min(activeCard.value + 1, cardCount - 1));
    }
}

function prevCard() {
    if (!isScrollingToCard.value) {
        scrollToCard(Math.max(activeCard.value - 1, 0));
    }
}

// Handle touch events for swipe functionality
let touchStartX = 0;

function handleTouchStart(e) {
  touchStartX = e.touches[0].clientX;
}

function handleTouchEnd(e) {
  const touchEndX = e.changedTouches[0].clientX;
  const diff = touchStartX - touchEndX;
  
  // Detect swipe direction and navigate accordingly
  if (diff > 50) { // Swipe left, go next
    nextCard();
  } else if (diff < -50) { // Swipe right, go previous
    prevCard();
  }
}

// Set initial card on mount
onMounted(() => {
  // ...existing onMounted code...
  
  // Initialize the slider to show the middle card on mobile
  if (window.innerWidth < 1024) {
    setTimeout(() => {
      scrollToCard(1);
    }, 100);
  }
});
</script>

<template>
    <Head title="Verkoop je auto, zonder omwegen">
        <link rel="apple-touch-icon" sizes="180x180" href="/apple-touch-icon.png">
        <link rel="icon" type="image/png" sizes="32x32" href="/favicon-32x32.png">
        <link rel="icon" type="image/png" sizes="16x16" href="/favicon-16x16.png">
        <link rel="manifest" href="/site.webmanifest">
        <link rel="mask-icon" href="/safari-pinned-tab.svg" color="#ff5a22">
        <meta name="msapplication-TileColor" content="#ff5a22">
        <meta name="theme-color" content="#ffffff">
        <meta property="og:url" content="https://mas.codespreview.nl">
        <meta property="og:type" content="website">
        <meta property="og:title" content="Verkoop je auto, zonder omwegen | mijnautosnelweg.nl">
        <meta property="og:description" content="Jouw route naar autoverkoop!">
        <meta property="og:image" content="/img/og_image.png">
        <meta name="twitter:card" content="summary_large_image">
        <meta property="twitter:domain" content="mas.codespreview.nl">
        <meta property="twitter:url" content="https://mas.codespreview.nl">
        <meta name="twitter:title" content="Verkoop je auto, zonder omwegen | mijnautosnelweg.nl">
        <meta name="twitter:description" content="Jouw route naar autoverkoop!">
        <meta name="twitter:image" content="/img/og_image.png">
    </Head>

    <Header @focus-license-input="focusLicenseInput" />

    <div id="kenteken" v-motion-fade-visible-once class="h-full min-h-[52rem] md:min-h-[60rem] md:max-h-[1024px] overflow-hidden">
        <div class="relative h-full">
            <div class="absolute -z-30 h-full w-full bg-royalblue-500">
                <video class="absolute object-cover h-full w-full opacity-90" autoplay muted loop playsinline :poster="'/img/hero_video_poster.webp'">
                    <source :src="'/vid/hero_kliktikverkocht.mp4'" type="video/mp4" />
                </video>
            </div>
            <div class="absolute inset-0 -z-20 bg-gradient-to-t from-royalblue-500 via-royalblue-500/35 to-royalblue-500/15 via-50% lg:via-35%"></div>
            <div class="absolute inset-0 mx-auto max-w-7xl flex w-full justify-between h-full ">
                <div class="relative flex gap-8 px-8 w-full justify-center 2xl:justify-end h-full">
                    <div class="flex absolute -left-16 sm:left-0 lg:left-24 xl:left-40 right-0 h-full w-[200vw] -z-10 flex-row">
                        <img :src="'/img/mas_hero_vector.svg'" class=" h-4/6 sm:h-5/6 md:h-full object-cover object-left" />
                    </div>
                </div>
            </div>
            <div class="absolute inset-0 mx-auto max-w-7xl px-4 sm:px-6 2xl:px-0 flex flex-col"> 
                <div class="flex flex-1 flex-col justify-center max-w-sm sm:max-w-md md:max-w-xl md:pl-20 md:ml-auto mt-24 md:mt-16">
                    <h1 class="md:text-right text-8xl font-medium tracking-tight text-white font-teachers text-shadow">
                        klik tik <br><span class="text-royalblue-500">verkocht</span></h1>
                    <p class="md:text-right mt-4 sm:mt-6 md:ml-14 text-base sm:text-lg md:text-xl font-light leading-relaxed text-white text-shadow">
                        Ontvang direct een vrijblijvend bod en verkoop je auto veilig en betrouwbaar.</p>
                    
                    <!-- Replace the old form with the new LicensePlateInputForm component -->
                    <div class="mt-8 sm:mt-10 flex md:justify-end">
                        <LicensePlateInputForm ref="licenseInputRef" buttonText="Verder" buttonColor="primary" formClasses="flex flex-wrap gap-2 md:gap-4 md:justify-end"
                            inputClasses="w-auto sm:w-72 md:w-80 h-12 sm:h-14 md:h-16" buttonClasses="px-6 sm:px-8 md:px-10" errorClasses="text-white text-sm mt-3" />
                    </div>
                    
                    <div class="w-full mt-2 flex md:justify-end">
                        <CustomLink href="/autoaanmelden" color="white" :animated="true" class="text-shadow">
                            Verder zonder kenteken
                        </CustomLink>
                    </div>
                </div>
                <div class="my-8 md:my-10 lg:my-14 gap-4 md:gap-6 lg:gap-8 text-base leading-7 text-gray-600 w-full grid grid-cols-1 lg:grid-cols-3">
                    <div v-for="feature in features" :key="feature.name" class="flex flex-row gap-4 items-center">
                        <div class="shadow-lg shadow-deepblue/15 bg-brightorange flex h-16 min-w-16 w-16 place-content-center place-items-center rounded-md">
                            <font-awesome-icon :icon="['far', feature.icon]" class="text-white h-6 w-6 shrink-0" />
                        </div>
                        <div class="flex flex-col w-full max-w-md">
                            <p class="font-bold text-brightorange text-shadow">{{ feature.name }}</p>
                            <p class="text-sm sm:text-base text-white text-shadow">{{ feature.description }}</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="relative">
        <div class="pt-16 sm:pt-20 md:py-24 lg:py-28">
            <div v-motion-slide-visible-once-bottom class="flex flex-col">
                <div class="mx-auto w-full max-w-7xl px-4 sm:px-6 2xl:px-0 flex flex-col items-baseline">
                    <div class="flex flex-row w-full justify-between gap-4">
                        <h2 class="text-base font-bold leading-7 text-brightorange font-grotesk text-nowrap">Klanten ervaringen</h2>
                        <div class="flex items-center gap-0.5">
                            <font-awesome-icon :icon="['fas', 'star']" v-for="rating in [0, 1, 2, 3]" :key="rating" class="text-yellow-500 h-3.5 w-3.5 shrink-0" aria-hidden="true" />
                            <font-awesome-icon :icon="['fas', 'star-half-stroke']" class="text-yellow-500 h-3.5 w-3.5 shrink-0" aria-hidden="true" />
                            <p class="sr-only">4.6 van de 5 sterren</p>
                            <p class="text-right text-nowrap ml-1 text-white text-xs sm:text-sm md:hidden">4.6 op <a target="_blank" rel="noopener noreferrer" href="https://www.google.com/search?q=Mijnautosnelweg+Reviews" class="underline font-bold">Google</a></p>
                            <p class="text-right text-nowrap ml-1 text-white text-xs sm:text-sm hidden md:block">4.6 op <a target="_blank" rel="noopener noreferrer" href="https://www.google.com/search?q=Mijnautosnelweg+Reviews" class="underline font-bold">Google</a></p>
                        </div>
                    </div>
                    <p class="mt-2 md:mt-4 lg:mt-8 text-4xl font-normal tracking-tight text-white sm:text-5xl md:text-6xl text-balance font-teachers">Onze klanten <span class="text-brightorange font-semibold">waarderen</span> ons.</p>
                </div>
                <TestimonialSlider :testimonials="testimonials" />
            </div>
        </div>
        <div id="hoe" class="mx-auto max-w-7xl px-4 sm:px-6 2xl:px-0 py-16 sm:py-20 md:py-24 lg:py-28">
            <div v-motion-slide-visible-once-left class="flex flex-col">
                <p class="mt-2 md:mt-4 lg:mt-8 text-4xl placeholder:font-normal tracking-tight text-royalblue-500 sm:text-5xl md:text-6xl text-balance font-teachers">
                    Zo verkoop je jouw auto via <span class="text-brightorange font-semibold">Mijnautosnelweg</span></p>
                <div class="mt-12 lg:mt-16">
                    <div class="grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-4 gap-4 lg:gap-6 items-stretch">
                        <div class="sm:rounded-xl sm:bg-white sm:shadow-2xl shadow-deepblue sm:p-4 md:p-6 flex flex-col h-full relative overflow-hidden group border-b-2 sm:border-b-0 pb-2 border-royalblue-500/15">
                            <div class="relative z-10">
                                <div class="flex items-center gap-4 flex-row sm:flex-col sm:items-start">
                                    <font-awesome-icon :icon="['fas', 'list-check']" class="h-6 sm:h-10 w-6 sm:w-10 shrink-0 text-royalblue-500" />
                                    <h3 class="text-xl text-royalblue-500 my-3 md:my-6 text-balance">Jouw auto aanmelden op mijnautosnelweg</h3>
                                </div>
                                <p class="text-gray-600 py-1.5 md:py-3">In ons gebruiksvriendelijke aanmeldformulier kun je jouw auto eenvoudig en snel aanmelden. Vul de gegevens zorgvuldig in, zodat we je snel en nauwkeurig een eerlijk bod kunnen doen. Dit proces is volledig vrijblijvend.</p>
                                <CustomLink href="#kenteken" color="brightorange" :animated="true" class="mt-3 inline-flex items-center font-semibold transition-all gap-1 hover:gap-2">
                                    Kenteken invoeren
                                    <font-awesome-icon :icon="['fas', 'arrow-right']" class="h-4 w-4 shrink-0" />
                                </CustomLink>
                            </div>
                        </div>
                        <div class="sm:rounded-xl sm:bg-white sm:shadow-2xl shadow-deepblue sm:p-4 md:p-6 flex flex-col h-full relative overflow-hidden group border-b-2 sm:border-b-0 pb-2 border-royalblue-500/15">
                            <div class="relative z-10">
                                <div class="flex items-center gap-4 flex-row sm:flex-col sm:items-start">
                                    <font-awesome-icon :icon="['fas', 'headset']" class="h-6 sm:h-10 w-6 sm:w-10 shrink-0 text-royalblue-500" />
                                    <h3 class="text-xl text-royalblue-500 my-3 md:my-6 text-balance">Wij nemen contact met je op</h3>
                                </div>
                                <p class="text-gray-600 py-1.5 md:py-3">Onze gespecialiseerde verkopers nemen persoonlijk contact met je op om de details van je aanmelding te bespreken. Op basis van je gegevens zoeken wij direct naar een geschikte koper uit ons betrouwbare netwerk.</p>
                            </div>
                        </div>
                        <div class="sm:rounded-xl sm:bg-white sm:shadow-2xl shadow-deepblue sm:p-4 md:p-6 flex flex-col h-full relative overflow-hidden group border-b-2 sm:border-b-0 pb-2 border-royalblue-500/15">
                            <div class="relative z-10">
                                <div class="flex items-center gap-4 flex-row sm:flex-col sm:items-start">
                                    <font-awesome-icon :icon="['fas', 'comments-dollar']" class="h-6 sm:h-10 w-6 sm:w-10 shrink-0 text-royalblue-500" />
                                    <h3 class="text-xl text-royalblue-500 my-3 md:my-6 text-balance">Het onderhandel proces gaat van start</h3>
                                </div>
                                <p class="text-gray-600 py-1.5 md:py-3">Onze verkopers onderhandelen met potentiële kopers uit ons professionele netwerk om je de beste biedingen voor te leggen. Je hebt altijd de vrijheid om een bod wel of niet te accepteren, zonder enige verplichting.</p>
                            </div>
                        </div>
                        <div class="sm:rounded-xl sm:bg-white sm:shadow-2xl shadow-deepblue sm:p-4 md:p-6 flex flex-col h-full relative overflow-hidden group border-b-2 sm:border-b-0 pb-2 border-royalblue-500/15">
                            <div class="relative z-10">
                                <div class="flex items-center gap-4 flex-row sm:flex-col sm:items-start">
                                    <font-awesome-icon :icon="['fas', 'hand-holding-circle-dollar']" class="h-6 sm:h-10 w-6 sm:w-10 shrink-0 text-royalblue-500" />
                                    <h3 class="text-xl text-royalblue-500 my-3 md:my-6 text-balance">De verkoop word afgerond</h3>
                                </div>
                                <p class="text-gray-600 py-1.5 md:py-3">Zodra je akkoord gaat met het ontvangen aanbod, zorgen wij voor een snelle en veilige afronding van de verkoop. Via ons portaal krijg je gedetailleerde updates over elke stap in het proces, zodat je altijd op de hoogte bent van de voortgang van je verkoop.</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="absolute inset-0 -z-10">
            <div class="relative w-full h-2/6 md:h-3/5">
                <div class="absolute z-10 w-full h-full left-0 right-0 -top-2 bottom-0 bg-gradient-to-b from-royalblue-500 via-royalblue-500 to-transparent via-45%"></div>
            </div>
        </div>
    </div>

    <LicensePlateBanner v-motion-slide-visible-once-bottom variant="small" title="In één stap naar je bod" @submit="submit" />

    <div id="methode" class="overflow-hidden xl:overflow-visible mx-auto w-full max-w-7xl px-4 sm:px-6 space-y-12 sm:space-y-16 md:space-y-20 lg:space-y-0 2xl:px-0 grid grid-cols-1 lg:grid-cols-2 py-16 sm:py-20 md:py-24 lg:py-28 gap-8">
        <div v-motion-slide-visible-once-bottom class="flex flex-col sm:flex-row lg:flex-col gap-x-8 gap-y-16 md:gap-x-16 lg:gap-x-20 items-center">
            <img :src="'/img/snelensimpel_large.webp'" alt="Snel en simpel, zo geregeld"
                class="rounded-xl ring-gray-400/10 sm:w-1/3 lg:w-full sm:h-96 lg:h-80 object-cover object-top lg:object-center shadow-3xl shadow-deepblue/30" />
            <div>
                <h2 class="text-base font-bold leading-7 text-brightorange font-grotesk">Onze methode</h2>
                <p class="mt-2 md:mt-4 lg:mt-8 text-4xl font-normal tracking-tight text-royalblue-500 sm:text-5xl md:text-6xl text-balance font-teachers">
                    <span class="font-semibold">Snel</span> en <span class="font-semibold">simpel,</span> zo geregeld.</p>
                <p class="mt-8 md:mt-10 lg:mt-14 text-lg leading-8 text-gray-600 text-balance">Vul de details van je auto in op ons online formulier. Ons netwerk van kopers zal biedingen uitbrengen. Kies het beste bod en verkoop je auto zonder gedoe.</p>
            </div>
        </div>
        <div v-motion-slide-visible-once-bottom class="flex flex-col sm:flex-row lg:flex-col gap-x-8 gap-y-16 md:gap-x-16 lg:gap-x-20 items-center">
            <img :src="'/img/leunachterover_large.webp'" alt="Leun achterover, wij regelen het"
                class="rounded-xl ring-gray-400/10 sm:w-1/3 lg:w-full sm:h-96 lg:h-80 sm:my-12 md:my-0 object-cover object-top lg:object-center shadow-3xl shadow-deepblue/30" />
            <div class="order-first lg:order-last"> 
                <h2 class="text-base font-bold leading-7 text-brightorange font-grotesk">Autoverkoop op autopilot</h2>
                <p class="mt-2 md:mt-4 lg:mt-8 text-4xl font-normal tracking-tight text-royalblue-500 sm:text-5xl md:text-6xl text-balance font-teachers">
                    Leun achterover, wij <span class="font-semibold">regelen</span> het.</p>
                <p class="mt-8 md:mt-10 lg:mt-14 text-lg leading-8 text-gray-600 text-balance">Een toegewijde medewerker begeleidt je door het hele verkoopproces. Ontvang een eerlijk bod zonder zelf tijd te verdoen aan onderhandelingen. Ga akkoord met het bod en wij regelen de rest, van papierwerk tot betaling.</p>
            </div>
        </div>
        <div v-motion-slide-visible-once-left class="flex flex-col gap-x-8 gap-y-16 md:gap-x-16 lg:gap-x-20 lg:col-span-2">
            <p class="max-w-2xl mt-2 md:mt-8 lg:mt-16 text-4xl font-normal tracking-tight text-royalblue-500 sm:text-5xl md:text-6xl sm:text-center lg:text-left text-balance font-teachers">
                Waarom kiezen voor <span class="text-brightorange font-semibold"> mijnautosnelweg</span></p>
            
            <!-- Mobile comparison slider with controls -->
            <div class="relative lg:hidden -mb-8">
                <!-- Overflow container for horizontal scrolling -->
                <div ref="comparisonSlider" class="flex overflow-x-hidden snap-x snap-mandatory scrollbar-hide px-6 -mx-6 -space-x-20 pb-20" 
                     style="scroll-snap-type: x mandatory; -webkit-overflow-scrolling: touch;" 
                     @touchstart="handleTouchStart" @touchend="handleTouchEnd">

                    <!-- Card 1: Dealer -->
                    <div class="flex w-screen px-2 flex-shrink-0 snap-center py-10 justify-end pr-[4%]">
                        <div class="w-11/12 h-full bg-white rounded-l-xl shadow-3xl shadow-deepblue/30 p-8 flex flex-col items-center text-royalblue-500">
                            <img :src="'/img/dealer.svg'" />
                            <h2 class="text-lg leading-7 font-grotesk mt-2">Verkopen aan een dealer</h2>
                            <h3 class="text-5xl font-bold my-3">€12.000</h3>
                            <p class="text-deepblue text-center mt-6">Bij de dealer ontvang je minder geld voor je auto, je hebt minder controle en er kan sprake zijn van verkoopdruk.<br><br>Als je een gunstige inruilwaarde wilt krijgen word je verplicht om bij dezelfde dealer een nieuwe auto aan te schaffen.</p>
                        </div>
                    </div>
                    
                    <!-- Card 2: Mijnautosnelweg (Featured) -->
                    <div class="w-full justify-center px-8 flex-shrink-0 flex snap-center z-10">
                        <div class="w-11/12 bg-royalblue-500 z-10 rounded-xl shadow-2xl shadow-deepblue/30 p-8 flex flex-col items-center text-white">
                            <img :src="'/img/mas.svg'" />
                            <img :src="'/img/mas_tekst.svg'" alt="mijnautosnelweg" class="mt-4 w-full max-w-sm h-auto"/>
                            <h3 class="text-6xl font-bold my-3">€13.000</h3>
                            <p class="text-center mt-6">Bij mijnautosnelweg bieden we je een snelle, veilige en makkelijke manier om je auto te verkopen.<br><br>Binnen 24 uur ontvang jij gratis en vrijblijvend een bod op jouw auto.<br><br>Wanneer je akkoord gaat ontvang je direct het bedrag op je rekening!</p>
                        </div>
                    </div>
                    
                    <!-- Card 3: Zelf verkopen -->
                    <div class="flex w-screen px-2 flex-shrink-0 snap-center py-10 justify-start pl-[4%]">
                        <div class="w-11/12 bg-white rounded-r-xl shadow-3xl shadow-deepblue/30 p-8 flex flex-col items-center text-royalblue-500">
                            <img :src="'/img/zelf.svg'" />
                            <h2 class="text-lg leading-7 font-grotesk mt-2">Zelf online verkopen</h2>
                            <h3 class="text-5xl font-bold my-3">€13.500</h3>
                            <p class="text-deepblue text-center mt-6">Online autoverkoop brengt onzekerheid met zich mee.<br><br>Je hebt te maken vreemden aan de deur of mensen die niet komen opdagen.<br><br>Daarnaast is het tijdrovend, je moet advertenties maken en onderhandelen.</p>
                        </div>
                    </div>
                </div>
                
                <!-- Pagination indicators -->
                <div class="absolute bottom-4 left-0 right-0 flex justify-center space-x-2 mt-4">
                    <button 
                        v-for="index in cardCount" 
                        :key="index-1" 
                        @click="scrollToCard(index-1)" 
                        class="w-2 h-2 rounded-full transition-all duration-300"
                        :class="index-1 === activeCard ? 'bg-brightorange w-8' : 'bg-gray-300'">
                    </button>
                </div>
            </div>
            
            <!-- Desktop comparison layout -->
            <div class="hidden lg:flex flex-col lg:flex-row items-center -space-y-2">
                <div class="w-11/12 lg:w-full h-full justify-center bg-white mx-2 lg:mx-0 rounded-l-xl shadow-3xl shadow-deepblue/30 p-4 pb-6 sm:p-8 flex flex-col items-center text-royalblue-500">
                    <img :src="'/img/dealer.svg'" />
                    <h2 class="text-lg leading-7 font-grotesk mt-2">Verkopen aan een dealer</h2>
                    <h3 class="text-5xl font-bold my-3">€12.000</h3>
                    <p class="text-deepblue text-center mt-6">Bij de dealer ontvang je minder geld voor je auto, je hebt minder controle en er kan sprake zijn van verkoopdruk.<br><br>Als je een gunstige inruilwaarde wilt krijgen word je verplicht om bij dezelfde dealer een nieuwe auto aan te schaffen.</p>
                </div>
                <div class="w-full bg-royalblue-500 h-[105%] justify-center ring-royalblue-500 scale-105 z-10 rounded-xl shadow-3xl shadow-deepblue p-6 sm:p-8 flex flex-col items-center text-white">
                    <img :src="'/img/mas.svg'" />
                    <img :src="'/img/mas_tekst.svg'" alt="mijnautosnelweg" class="mt-4 w-full max-w-sm h-auto"/>
                    <h3 class="text-6xl font-bold my-3">€13.000</h3>
                    <p class="text-center mt-6">Bij mijnautosnelweg bieden we je een snelle, veilige en makkelijke manier om je auto te verkopen.<br><br>Binnen 24 uur ontvang jij gratis en vrijblijvend een bod op jouw auto.<br><br>Wanneer je akkoord gaat ontvang je direct het bedrag op je rekening!</p>
                </div>
                <div class="w-11/12 lg:w-full h-full justify-center bg-white mx-2 lg:mx-0 lg:my-8 rounded-r-xl shadow-3xl shadow-deepblue/30 p-4 pt-6 sm:p-8 flex flex-col items-center text-royalblue-500">
                    <img :src="'/img/zelf.svg'" />
                    <h2 class="text-lg leading-7 font-grotesk mt-2">Zelf online verkopen</h2>
                    <h3 class="text-5xl font-bold my-3">€13.500</h3>
                    <p class="text-deepblue text-center mt-6">Online autoverkoop brengt onzekerheid met zich mee.<br><br>Je hebt te maken vreemden aan de deur of mensen die niet komen opdagen.<br><br>Daarnaast is het tijdrovend, je moet advertenties maken en onderhandelen.</p>
                </div>
            </div>
        </div>
    </div>

    <LicensePlateBanner v-motion-slide-visible-once-bottom v-motion-slide-bottom variant="big" title="Jouw route naar autoverkoop" subtitle="Ontvang direct een vrijblijvend bod en verkoop je auto veilig en betrouwbaar." @submit="submit" />

    <div id="specialisten" class="mx-auto w-full max-w-7xl px-4 sm:px-6 2xl:px-0 py-16 sm:py-20 md:py-24 lg:py-28">
        <div v-motion-slide-visible-once-bottom class="flex flex-col sm:flex-row gap-x-8 gap-y-16 md:gap-x-16 lg:gap-x-20 items-center">
            <img :src="'/img/onsteam_large.webp'" alt="Ons team staat klaar om je te helpen"
                class="rounded-xl ring-gray-400/10 sm:w-1/3 lg:w-1/2 lg:max-w-2xl h-96 lg:h-[40rem] object-cover object-top lg:object-center shadow-3xl shadow-deepblue/30" />
            <div class="flex flex-col h-full justify-center">
                <h2 class="text-base font-bold leading-7 text-brightorange font-grotesk">Onze specialisten</h2>
                <p class="mt-2 md:mt-4 lg:mt-8 text-4xl font-normal tracking-tight text-royalblue-500 sm:text-5xl md:text-6xl text-balance font-teachers">
                    Ons <span class="font-semibold">team</span> staat klaar om je te <span class="text-brightorange">helpen</span>.</p>
                <p class="mt-8 md:mt-10 lg:mt-14 text-lg leading-8 text-gray-600 text-balance">Een toegewijde medewerker begeleidt je door het hele verkoopproces. Ontvang een eerlijk bod zonder zelf tijd te verdoen aan onderhandelingen. Ga akkoord met het bod en wij regelen de rest, van papierwerk tot betaling.</p>
            </div>
        </div>
    </div>

    <div class="relative overflow-clip">
        <div id="contact" class="mx-auto grid max-w-7xl px-4 sm:px-6 2xl:px-0 pb-16 sm:py-20 md:py-24 lg:py-28">
            <div class="grid grid-cols-1 gap-x-8 md:gap-x-16 lg:gap-x-20 lg:grid-cols-2">
                <div v-motion-slide-visible-once-left class="flex flex-col">
                    <h2 class="text-center md:text-left text-base font-bold leading-7 text-brightorange font-grotesk">Contact</h2>
                    <p class="text-center md:text-left mt-2 md:mt-4 lg:mt-8 text-4xl font-normal tracking-tight text-royalblue-500 sm:text-5xl md:text-6xl text-balance font-teachers max-w-2xl">
                        Kom in <span class="text-brightorange font-semibold">contact</span></p>
                    <div class="flex flex-col justify-between mt-8 md:mt-10 lg:mt-14 space-y-4 md:space-y-6 lg:space-y-8 text-base leading-7 text-gray-600 lg:max-w-none">
                        <a :href="contact.href" v-for="contact in contacts" :key="contact.name" class="inline-flex w-full max-w-72 flex-row gap-3 md:gap-6 items-center" target="_blank">
                            <div class="shadow-lg shadow-deepblue/15 bg-brightorange flex h-16 min-w-16 w-16 place-content-center place-items-center rounded-md">
                                <font-awesome-icon :icon="[contact.type, contact.icon]" class="text-white h-6 w-6 shrink-0" />
                            </div>
                            <div class="flex flex-col w-full">
                                <p class="font-semibold text-royalblue-500">{{ contact.name }}</p>
                                <p>{{ contact.description }}</p>
                            </div>
                        </a>
                    </div>
                </div>
                <form v-motion-slide-visible-once-bottom @submit.prevent="submitContact" ref="contactFormDom" class="relative mt-8 md:mt-10 lg:mt-14">
                    <div class="bg-white p-4 sm:p-8 md:p-12 shadow-3xl shadow-brightorange/40 rounded-2xl">
                        <div class="grid grid-cols-1 gap-x-8 gap-y-6 sm:grid-cols-2">
                            <div>
                                <label for="first-name" class="block text-sm font-semibold leading-6 text-deepblue">Voornaam</label>
                                <div class="mt-1.5">
                                    <input type="text" name="first-name" id="first-name" autocomplete="given-name" v-model="contactForm.first_name"
                                        class="block w-full rounded-md border-0 px-3.5 py-2 text-deepblue shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-brightorange sm:text-sm sm:leading-6" />
                                </div>
                                <div v-if="contactForm.errors.first_name" class="text-red-500 text-sm mt-1.5">{{ contactForm.errors.first_name }}</div>
                            </div>
                            <div>
                                <label for="last-name" class="block text-sm font-semibold leading-6 text-deepblue">Achternaam</label>
                                <div class="mt-1.5">
                                    <input type="text" name="last-name" id="last-name" autocomplete="family-name" v-model="contactForm.last_name"
                                        class="block w-full rounded-md border-0 px-3.5 py-2 text-deepblue shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-brightorange sm:text-sm sm:leading-6" />
                                </div>
                                <div v-if="contactForm.errors.last_name" class="text-red-500 text-sm mt-1.5">{{ contactForm.errors.last_name }}</div>
                            </div>
                            <div class="sm:col-span-2">
                                <label for="email" class="block text-sm font-semibold leading-6 text-deepblue">E-mailadres</label>
                                <div class="mt-1.5">
                                    <input type="email" name="email" id="email" autocomplete="email" v-model="contactForm.email"
                                        class="block w-full rounded-md border-0 px-3.5 py-2 text-deepblue shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-brightorange sm:text-sm sm:leading-6" />
                                </div>
                                <div v-if="contactForm.errors.email" class="text-red-500 text-sm mt-1.5">{{ contactForm.errors.email }}</div>
                            </div>
                            <div class="sm:col-span-2">
                                <label for="phone-number" class="block text-sm font-semibold leading-6 text-deepblue">Telefoonnummer</label>
                                <div class="mt-1.5">
                                    <input type="tel" name="phone-number" id="phone-number" autocomplete="tel" v-model="contactForm.phone_number"
                                        class="block w-full rounded-md border-0 px-3.5 py-2 text-deepblue shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-brightorange sm:text-sm sm:leading-6" />
                                </div>
                                <div v-if="contactForm.errors.phone_number" class="text-red-500 text-sm mt-1.5">{{ contactForm.errors.phone_number }}</div>
                            </div>
                            <div class="sm:col-span-2">
                                <label for="message" class="block text-sm font-semibold leading-6 text-deepblue">Bericht</label>
                                <div class="mt-1.5">
                                    <textarea name="message" id="message" rows="4" v-model="contactForm.message" 
                                        class="block w-full rounded-md border-0 px-3.5 py-2 text-deepblue shadow-sm ring-1 ring-inset min-h-32 ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-brightorange sm:text-sm sm:leading-6" />
                                </div>
                                <div v-if="contactForm.errors.message" class="text-red-500 text-sm mt-1.5">{{ contactForm.errors.message }}</div>
                            </div>
                        </div>
                        <div class="mt-8 flex justify-end">
                            <input type="submit" class="primary-btn" value="Verstuur">
                        </div>
                    </div>
                    <img :src="'img/contact_vector.svg'" alt="" class="hidden sm:block absolute -top-60 lg:-top-14 left-52 md:left-64 lg:-left-52 -z-10">
                </form>
                <div ref="contactFormSuccess" class="mt-8 md:mt-10 lg:mt-14 bg-white p-8 md:p-12 shadow-3xl shadow-deepblue/40 rounded-lg content-center" style="display: none">
                    <div class="flex flex-col text-center gap-12">
                        <font-awesome-icon :icon="['far', 'badge-check']" class="mx-auto h-12 w-12 text-brightorange" />
                        <span class="mt-4 text-sm font-semibold text-deepblue" id="contact_success">
                            Bedankt voor het invullen van het contactformulier. We nemen zo snel mogelijk contact met je op.</span>
                    </div>
                </div>
                <div ref="contactFormError" class="mt-8 md:mt-10 lg:mt-14 bg-white p-8 md:p-12 shadow-3xl shadow-deepblue/40 rounded-lg content-center" style="display: none">
                    <div class="flex flex-col text-center gap-12">
                        <font-awesome-icon :icon="['far', 'triangle-exclamation']" class="mx-auto h-12 w-12 text-red-500" />
                        <span class="mt-4 text-sm font-semibold text-deepblue" id="contact_error">
                            Er is iets fout gegaan tijdens het opsturen van je contactformulier. Onze ontwikkelaars zijn hier van op de hoogte gesteld.</span>
                    </div>
                </div>
            </div>
        </div>
            
        <LicensePlateBanner v-motion-slide-visible-once-bottom variant="small" title="In één stap naar je bod" @submit="submit" />

        <div v-motion-slide-visible-once-bottom id="faq" class="pt-16 sm:pt-20 md:pt-24 lg:pt-28">
            <div class="mx-auto max-w-7xl px-4 sm:px-6 2xl:px-0 ">
                <div class="mx-auto max-w-3xl">
                    <p class="mt-2 md:mt-4 lg:mt-8 text-4xl mx-auto font-normal tracking-tight text-white sm:text-5xl md:text-6xl sm:text-center text-balance font-teachers">
                        Veelgestelde <span class="font-semibold text-brightorange">vragen</span></p>
                    <p class="mt-8 md:mt-10 lg:mt-14 text-md lg:text-lg leading-6 lg:leading-8 text-white text-balance sm:text-center">
                        Vind snel en eenvoudig een antwoord op je vraag. Staat jouw vraag er niet bij? Neem dan gerust contact op met een van onze medewerkers door 
                        <CustomLink href="#contact" class="hidden md:inline-flex" color="white" :animated="true" fontWeight="bold">
                            een e-mail te sturen.
                        </CustomLink>
                    </p>
                </div>
                <div class="grid grid-cols-1 gap-x-8 lg:grid-cols-2 mt-8 md:mt-12 lg:mt-20">
                    <dl class="col-span-2 md:col-span-1 divide-y-2 divide-white/10">
                        <Disclosure as="div" v-for="faq in faqs" :key="faq.question" class="pt-6 pb-4" v-slot="{ open }">
                            <dt>
                                <DisclosureButton class="flex w-full items-start justify-between text-left text-white group">
                                    <span class="text-base font-semibold leading-7">{{ faq.question }}</span>
                                    <span class="ml-6 flex h-7 items-center">
                                        <font-awesome-icon :icon="['far', 'arrow-right']"
                                            :class="['transition-transform duration-300 h-6 w-6 text-white group-hover:text-lessbrightorange', open ? '-rotate-90 !text-brightorange' : '']"
                                            aria-hidden="true" />
                                    </span>
                                </DisclosureButton>
                            </dt>
                            <transition enter-active-class="transition duration-200 ease-out"
                                enter-from-class="translate-y-1 opacity-0"
                                enter-to-class="translate-y-0 opacity-100"
                                leave-active-class="transition duration-150 ease-in"
                                leave-from-class="translate-y-0 opacity-100"
                                leave-to-class="translate-y-1 opacity-0">
                                <DisclosurePanel as="dd" class="mt-2 pr-12">
                                    <p class="text-base leading-7 text-gray-200">{{ faq.answer }}</p>
                                </DisclosurePanel>
                            </transition>
                        </Disclosure>
                    </dl>
                    <dl class="col-span-2 md:col-span-1 divide-y-2 divide-white/10">
                        <Disclosure as="div" v-for="faq in faqs2" :key="faq.question" class="pt-6 pb-4" v-slot="{ open }">
                            <dt>
                                <DisclosureButton class="flex w-full items-start justify-between text-left text-white group">
                                    <span class="text-base font-semibold leading-7">{{ faq.question }}</span>
                                    <span class="ml-6 flex h-7 items-center">
                                        <font-awesome-icon :icon="['far', 'arrow-right']"
                                            :class="['transition-transform duration-300 h-6 w-6 text-white group-hover:text-lessbrightorange', open ? '-rotate-90 !text-brightorange' : '']"
                                            aria-hidden="true" />
                                    </span>
                                </DisclosureButton>
                            </dt>
                            <transition enter-active-class="transition duration-200 ease-out"
                                enter-from-class="translate-y-1 opacity-0"
                                enter-to-class="translate-y-0 opacity-100"
                                leave-active-class="transition duration-150 ease-in"
                                leave-from-class="translate-y-0 opacity-100"
                                leave-to-class="translate-y-1 opacity-0">
                                <DisclosurePanel as="dd" class="mt-2 pr-12">
                                    <p class="text-base leading-7 text-gray-200">{{ faq.answer }}</p>
                                </DisclosurePanel>
                            </transition>
                        </Disclosure>
                    </dl>
                </div>
            </div>
        </div>

        <div class="absolute h-full w-full inset-0 -z-40 flex flex-col">
            <div class="h-fit flex grow w-full bg-white"></div>
            <div class="h-3/6 w-full bg-gradient-to-b from-transparent to-royalblue-500 via-lessbrightorange via-25%"></div>
            <div class="h-fit flex grow w-full bg-royalblue-500"></div>
        </div>
    </div>

    <div v-if="showCookie" class="fixed bottom-0 left-0 right-0 border-t-2 border-royalblue-500 bg-white w-full flex flex-col md:flex-row items-center justify-between gap-4 px-6 py-3">
        <p class="text-balance text-center md:text-left">Mijnautosnelweg maakt gebruik van cookies om onze website te verbeteren, maar alleen met jouw toestemming. Bij instellingen lees je meer over hoe het werkt.</p>
        <div class="flex flex-row gap-4 items-center">
            <CustomLink @click="showCookieSettings = true;" color="secondary" :animated="true" class="hover:cursor-pointer">
                Instellingen
            </CustomLink>
            <a @click="acceptAllCookies" class="primary-btn hover:cursor-pointer">Accepteren</a>
        </div>
    </div>

    <TransitionRoot as="template" :show="showCookieSettings">
        <Dialog as="div" class="relative z-50">
            <div class="fixed left-0 right-0 top-0 bottom-0 z-[100] w-screen overflow-y-auto">
                <div class="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
                    <TransitionChild as="template" enter="ease-out duration-300"
                        enter-from="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                        enter-to="opacity-100 translate-y-0 sm:scale-100" leave="ease-in duration-200"
                        leave-from="opacity-100 translate-y-0 sm:scale-100"
                        leave-to="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95">
                        <DialogPanel
                            class="relative transform overflow-clip rounded-lg bg-white border shadow-deepblue/40 shadow-3xl px-4 pb-4 pt-5 text-left transition-all sm:my-8 sm:w-full sm:max-w-2xl sm:p-6">
                            <div
                                class="flex flex-col gap-4 p-4 overflow-y-auto  max-h-[512px] sm:max-h-[628px] md:max-h-[745px]">
                                                <div class="flex justify-between items-center mb-4 rounded-t sm:mb-5">
                                    <DialogTitle>
                                        <img class="h-8 w-auto mt-2" :src="'/img/logo_full.svg'"
                                            alt="mijnautosnelweg" />
                                    </DialogTitle>
                                </div>
                                <form action="#">
                                    <div class="mb-4 border-b">
                                        <h4 class="block mb-2 text-lg font-semibold text-deepblue ">Cookie instellingen
                                        </h4>
                                        <p class="block mb-4 text-sm text-deepblue ">Om deze Diensten te gebruiken,
                                            hebben we uw toestemming nodig. Door op “Alles accepteren” te klikken,
                                            verklaart u uw toestemming voor het gebruik van alle Diensten. U kunt ook uw
                                            toestemming verklaren door individueel op de schuifregelaars voor elke
                                            categorie cookies te klikken en opslaan.</p>
                                    </div>
                                    <div class="mb-4 border-b">
                                        <h4 class="block mb-2 text-lg font-semibold text-deepblue ">Essentiele cookies
                                        </h4>
                                        <p class="block mb-4 text-sm text-deepblue">Essentiële cookies worden gebruikt om de basisfunctionaliteiten van de website te waarborgen, zoals navigatie en toegang tot beveiligde gedeelten van de website. Zonder deze cookies kan de website niet naar behoren functioneren.</p>                                        <button v-if="!showEssential" type="button"
                                            class="mb-4 flex flex-row items-center gap-2 text-sm font-medium text-royalblue-500 hover:text-royalblue-500/80"
                                            @click="showEssential = true">
                                            <p>Cookies bekijken</p>
                                            <font-awesome-icon :icon="['far', 'chevron-right']"
                                                class="h-4 w-4 shrink-0" />
                                        </button>
                                        <button v-if="showEssential" type="button"
                                            class="mb-4 flex flex-row items-center gap-2 text-sm font-medium text-royalblue-500 hover:text-royalblue-500/80"
                                            @click="showEssential = false">
                                            <p>Cookies bekijken</p>
                                            <font-awesome-icon :icon="['far', 'chevron-down']"
                                                class="h-4 w-4 shrink-0" />
                                        </button>
                                        <div v-if="showEssential" class="transition-all duration-300 ease-in-out">
                                            <div class="mt-10 ring-1 ring-gray-300 mx-0 rounded-lg overflow-hidden">
                                                <table class="min-w-full divide-y divide-gray-300 border-b">
                                                    <thead class="bg-royalblue-500/5">
                                                        <tr>
                                                            <th scope="col"
                                                                class="table-cell px-3 py-3.5 flex-1 text-left text-sm font-semibold text-deepblue">
                                                                Naam
                                                            </th>
                                                            <th scope="col"
                                                                class="table-cell px-3 py-3.5 flex-1 text-left text-sm font-semibold text-deepblue">
                                                                Expiration
                                                            </th>
                                                            <th scope="col"
                                                                class="table-cell px-3 py-3.5 flex-1 text-left text-sm font-semibold text-deepblue">
                                                                Purpose
                                                            </th>
                                                        </tr>
                                                    </thead>
                                                    <tbody class="divide-y">
                                                        <tr>
                                                            <td
                                                                class="whitespace-nowrap table-cell px-3 py-4 text-sm text-gray-500">
                                                                mijnautosnelweg_session
                                                            </td>
                                                            <td
                                                                class="whitespace-nowrap table-cell px-3 py-4 text-sm text-gray-500">
                                                                2 uur
                                                            </td>
                                                            <td
                                                                class="whitespace-nowrap table-cell px-3 py-4 text-sm text-gray-500">
                                                                Zorgt dat je dat data veilig verstuurd word
                                                            </td>
                                                        </tr>
                                                        <tr>
                                                            <td
                                                                class="whitespace-nowrap table-cell px-3 py-4 text-sm text-gray-500">
                                                                XSRF-TOKEN
                                                            </td>
                                                            <td
                                                                class="whitespace-nowrap table-cell px-3 py-4 text-sm text-gray-500">
                                                                2 uur
                                                            </td>
                                                            <td
                                                                class="whitespace-nowrap table-cell px-3 py-4 text-sm text-gray-500">
                                                                Zorgt voor een naadloze ervaring
                                                            </td>
                                                        </tr>
                                                        <tr>
                                                            <td
                                                                class="whitespace-nowrap table-cell px-3 py-4 text-sm text-gray-500">
                                                                fontsCssCache
                                                            </td>
                                                            <td
                                                                class="whitespace-nowrap table-cell px-3 py-4 text-sm text-gray-500">
                                                                7 dagen
                                                            </td>
                                                            <td
                                                                class="whitespace-nowrap table-cell px-3 py-4 text-sm text-gray-500">
                                                                Geeft aan of de fonts al ingeladen zijn
                                                            </td>
                                                        </tr>
                                                    </tbody>
                                                </table>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="mb-4 border-b">
                                        <div class="relative flex justify-between">
                                            <h4 class="block mb-2 text-lg font-semibold text-deepblue ">Analytics
                                                cookies</h4>
                                            <Switch v-model="acceptAnalytics"
                                                class="group relative inline-flex h-5 w-10 flex-shrink-0 cursor-pointer items-center justify-center rounded-full focus:outline-none">
                                                <span class="sr-only">Use setting</span>
                                                <span aria-hidden="true"
                                                    class="pointer-events-none absolute h-full w-full rounded-md" />
                                                <span aria-hidden="true"
                                                    :class="[acceptAnalytics ? 'bg-brightorange' : 'bg-gray-200', 'pointer-events-none absolute mx-auto h-6 w-12 rounded-full transition-colors duration-200 ease-in-out']" />
                                                <span aria-hidden="true"
                                                    :class="[acceptAnalytics ? 'translate-x-5' : 'translate-x-0', 'pointer-events-none absolute left-0 inline-block h-5 w-5 transform rounded-full border border-gray-200 bg-white shadow ring-0 transition-transform duration-200 ease-in-out']" />
                                            </Switch>
                                        </div>
                                        <p class="block mb-4 text-sm text-deepblue">Analytics cookies worden gebruikt om informatie te verzamelen over hoe bezoekers onze website gebruiken. Deze informatie helpt ons om de website te verbeteren door inzicht te krijgen in het gebruik en de prestaties van de site.</p>                                        <button v-if="!showAnalytics" type="button"
                                            class="mb-4 flex flex-row items-center gap-2 text-sm font-medium text-royalblue-500 hover:text-royalblue-500/80"
                                            @click="showAnalytics = true">
                                            <p>Cookies bekijken</p>
                                            <font-awesome-icon :icon="['far', 'chevron-right']"
                                                class="h-4 w-4 shrink-0" />
                                        </button>
                                        <button v-if="showAnalytics" type="button"
                                            class="mb-4 flex flex-row items-center gap-2 text-sm font-medium text-royalblue-500 hover:text-royalblue-500/80"
                                            @click="showAnalytics = false">
                                            <p>Cookies bekijken</p>
                                            <font-awesome-icon :icon="['far', 'chevron-down']"
                                                class="h-4 w-4 shrink-0" />
                                        </button>
                                        <div v-if="showAnalytics" class="transition-all duration-300 ease-in-out">
                                            <table class="mt-4 mb-4 w-full border bg-white rounded-xl overflow-hidden">
                                                <thead class="border-b bg-royalblue-500/5">
                                                    <tr>
                                                        <th class="px-4 py-2 text-left">Naam</th>
                                                        <th class="px-4 py-2 text-left">Expiration</th>
                                                        <th class="px-4 py-2 text-left">Purpose</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <tr>
                                                        <th class="px-4 py-2 font-normal">
                                                            <p>_ga</p>
                                                        </th>
                                                        <th class="px-4 py-2 font-normal">
                                                            <p>2 Jaar</p>
                                                        </th>
                                                        <th class="px-4 py-2 font-normal">
                                                            <p>Google analytics</p>
                                                        </th>
                                                    </tr>
                                                    <tr>
                                                        <th class="px-4 py-2 font-normal">
                                                            <p>_ga_KQVNRHT4TX</p>
                                                        </th>
                                                        <th class="px-4 py-2 font-normal">
                                                            <p>2 Jaar</p>
                                                        </th>
                                                        <th class="px-4 py-2 font-normal">
                                                            <p>Google analytics</p>
                                                        </th>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                </form>
                                <div class="mt-4 flex justify-end items-center space-x-6">
                                    <button @click="acceptCookies" type="button" class="group transition-all duration-300 ease-in-out inline-flex items-center border-b-2 border-transparent pt-1 text-base font-semibold  text-royalblue-500 hover:text-royalblue-500/80">
                                        <span class="bg-left-bottom bg-gradient-to-r from-brightorange to-brightorange bg-[length:0%_2px] bg-no-repeat group-hover:bg-[length:100%_2px] transition-all duration-500 ease-out">
                                            Opslaan en verder
                                        </span>
                                    </button>
                                    <button type="button"
                                        class="inline-flex w-auto justify-center rounded-md bg-brightorange px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-brightorange/80 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-royalblue-500 sm:col-start-2"
                                        @click="acceptAllCookies">Alles accepteren</button>
                                </div>
                            </div>
                        </DialogPanel>
                    </TransitionChild>
                </div>
            </div>
        </Dialog>
    </TransitionRoot>

    <Footer />
</template>

<style scoped>
/* Hide scrollbar for Chrome, Safari and Opera */
.scrollbar-hide::-webkit-scrollbar {
  display: none;
}

/* Hide scrollbar for IE, Edge and Firefox */
.scrollbar-hide {
  -ms-overflow-style: none;  /* IE and Edge */
  scrollbar-width: none;  /* Firefox */
}
</style>
